const ResultData = [
  {
    type: 1,
    title: '单纯饮食失衡型',
    enTitle: 'simple',
    fat: '全身',
    weekCardIcon:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/0d3e779d83801c8c2791138e14a234d6.png', //周卡开通图标
    titleImage:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/081df50317ba9b7e53499f8a0e9989ba.png', //类型图片
    foodImage:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/9aa48740144e91dec6dac5d64e16a25e.png', //超级食物图片
    coachSay: {
      text: '<span style="background: #FFFDC0;">不合理的饮食结构和进食时间，</span>是形成单纯性饮食失衡体质的主要原因。此类人群要么是从未尝试过减脂，要么是反复尝试却从未成功，身体在恶性循环下进入了炎症状态。<span style="background: #FFFDC0;">炎症致使甲状腺激素、肾上腺激素、胰岛素、雌激素分泌异常，同时也影响了下丘脑对食欲的调控能力，</span>会让人不停地想要进食。此类人群屡次减脂失败，很大程度上是因为<span style="background: #FFFDC0;">缺乏一个科学合理且能长期坚持的饮食方案和监督，</span>在满足食欲的同时能循序渐进地进行饮食控制。每个人的口味、作息、环境都不同，建议咨询专业营养师为您设计方案并且周期性更新方案哦。',
      effect:
        '长期的饮食结构不合理，非常容易导致<span style="background: #FFFDC0;">身体激素分泌紊乱，并且大幅加重身体代谢器官的负担。</span>当身体代谢速率越来越慢，人体对脂肪的处理能力也就会越来越弱，当代谢能力追不上脂肪积累速度，就会严重损害肝细胞，出现脂肪肝问题，也非常易引起<span style="background: #FFFDC0;">心脑血管疾病、糖尿病、肝硬化</span>等疾病。值得一提的是，脂肪肝并非体重基数大的人群独有的，由于营养不良，蛋白质缺乏，即使是体重基数小的人群也可能成为其中的一员。'
    },
    //首要解决问题
    firstList: [
      {
        title: '代谢缓慢',
        icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/c17e56cfa0149747f35a22fa90783b4c.png',
        text: '激素分泌紊乱的人会比常人更渴望摄入糖、碳水等食物，此类食物摄入越多，激素分泌就越不稳定，易陷入恶性循环'
      },
      {
        title: '饮食失衡',
        icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/a5f5a329cdfeb397856195986be52e3e.png',
        text: '不合理的饮食结构，势必加重身体代谢负担，导致代谢速率变慢，脂肪和毒素堆积在身体中无法正常排出，肥胖与健康问题接踵而至'
      },
      {
        title: '情绪压力',
        icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/486210ed748d37014db8fe4b7e236df0.png',
        text: '熬夜、精神压力等不良生活习惯会加剧胰岛素分泌紊乱，增加进食欲望'
      }
    ],
    plan1: {
      less: '5-8',
      lessImage:
        'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/d26bcb9445d5577f1b4fab07d034aca4.png',
      methodImage:
        'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/208ab51977a827666d20468e84ac24d5.png',
      consultUrl:
        '/miniProgram?userName=gh_0d804ee2c21b&path=pages%2Fimage-page%2Findex%3Fqrcode%3Dhttps%253A%252F%252Fbtw-common-data.betterwestar.com%252Fbtw-admin%252Fadmin-common-data%252F2025-04%252Fc3e154d07c2f361cb37d834a0719eaf8_wh%253D396_396.png',
      miniProgramRouterUrl:
        'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/226b9bf60e14536600c7efd05ea8b06e.png'
    },
    plan2: {
      //cardImage: "https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/cafbd5a4d1fa0433d1193f017e83694b.png",
      cardImage:
        'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/c13ebd693625851dad9c93a673f56334.png',
      food: '燕麦',
      buyUrl: '/VipBuyPage',
      rightImage:
        'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/daa2428ad81bec11cf0c15d431655a1d.png'
    },
    recommendation: {
      controlFood: {
        desc: '高糖食物、精制碳水、劣质脂肪',
        list: [
          {
            icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/04bdeeceadddba4acb9696a3d2f50137.png',
            name: '炸鸡、薯条',
            tips: '油炸食品是一种高热量、高脂肪、高盐分的食品，会让肝脏对废物的处理量增加，所以肝脏的负担就变得更加沉重，加剧失衡问题。'
          },
          {
            icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/d9535c2379d65c6486792e31209edee8.png',
            name: '榴莲',
            tips: '榴莲属于一种高糖水果，对于胰岛素敏感性低的人群，如果吃高糖食物，很可能会影响到全身各器官的代谢功能，加重代谢负担。'
          },
          {
            icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/6ebb47caaae1fce35585be324b95b610.png',
            name: '五花肉',
            tips: '五花肥肉是高脂、高热量的肉类食品，含有饱和脂肪，可能增加胰岛素抵抗，使血糖控制更为困难。'
          },
          {
            icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/2b4a702bce20819809f20aa543e175ab.png',
            name: '冰淇淋',
            tips: '冰淇淋是高糖、高脂食物，能在短时间内让血糖陡然升高，从而加剧激素失衡问题。'
          },
          {
            icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/5476d8bef889a96696aac94fd26b81f1.png',
            name: '黄油、奶油',
            tips: '过多的油脂进入体内之后，会影响身体的代谢功能，很容易加剧激素失衡的问题。'
          },
          {
            icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/8f571914a7532ab6caba54d9d71ae92d.png',
            name: '糕点',
            tips: '糕点中含有大量的糖，当人体血糖水平因高糖食物而大幅度波动时，会给身体和内分泌系统造成巨大压力，加剧激素失衡问题。'
          },
          {
            icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/0bccd6958be2c9adeebbda93dc006cb7.png',
            name: '榨菜',
            tips: '腌制食物中含有大量的盐，高盐食物会加剧激素失衡的问题。'
          },
          {
            icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/c6f8e5e7bb082576e52799fd30a68383.png',
            name: '动物内脏',
            tips: '对于长期单纯性饮食失衡的人群，其胆固醇排放速度慢于常人，血脂相应更高，因此一定要减少胆固醇的摄入。'
          }
        ]
      },
      recommendFood: {
        desc: '富含纤维素的低糖食物、高蛋白食物',
        list: [
          {
            icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/c19bec0a25483cb9019f8451e3868b29.png',
            name: '燕麦'
          },
          {
            icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/09305cf7d12fa3c65633582350ec5b14.png',
            name: '苹果'
          },
          {
            icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/8929a809e5041fbcd5fc03da0b088574.png',
            name: '豆腐'
          }
        ]
      },
      consultUrl: ''
    },
    selectPlanUrl:
      '/miniProgram?userName=gh_0d804ee2c21b&path=pages%2Fimage-page%2Findex%3Fqrcode%3Dhttps%253A%252F%252Fbtw-common-data.betterwestar.com%252Fbtw-admin%252Fadmin-common-data%252F2025-04%252F87b508b22e070d0cda35178e304fadf0_wh%253D396_396.png'
  },
  {
    type: 2,
    title: '肝脏胰岛素抵抗型',
    enTitle: 'liver',
    fat: '腰腹',
    weekCardIcon:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/9b8c0ccc381d5588e657ff4fc4938e5b.png',
    titleImage:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/95733339c3ed3e1debe675ae198eb1be.png', //类型图片
    foodImage:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/2495c12b329687919df0eccd71efc23b.png', //超级食物图片
    coachSay: {
      text: '<span style="background: #FFFDC0;">高糖分食物和精制碳水的摄入、不规律进食（跳过某一餐）、遗传</span>（如三代亲属中有糖尿病患者）等，都是可能造成肝脏胰岛素抵抗型问题体质的原因。渴望吃碳水、油炸和甜味食物不是你的错，是每当你面对这类食物时，身体会分泌让你快乐的<span style="background: #FFFDC0;">多巴胺</span>暗中鼓励你的行为，久而久之身体习惯了血液中的高血糖，当血糖波动幅度大时，很容易让精力变差、注意力难以集中甚至引起头晕、头痛，而吃点零食或下一餐大吃一顿是使你“打鸡血“的最快方式，这便是<span style="background: #FFFDC0;">血糖过山车，</span>也是你的减脂难题循环往复的原因。',
      effect:
        '肝脏和胆是人体消化、运输、储存脂肪的重要器官，肝脏和胰岛素出现问题时，会使人体对脂肪的处理能力变弱，也会让降低身体细胞对胰岛素的反应，从而导致<span style="background: #FFFDC0;">人体血糖水平异常，引发脂质代谢紊乱，让身体加速促进脂肪的合成与储存，</span>让你比别人更易胖之外，还会增加<span style="background: #FFFDC0;">脂肪肝、糖尿病、动脉硬化、冠心病</span>等疾病风险。同时，血液中过多的糖会引起<span style="background: #FFFDC0;">糖化反应，就是加速人体衰老，表现为面黄、皮肉松弛等问题，</span>建议尽快在<span style="background: #FFFDC0;  ">专业医生或营养师</span>的帮助下及时从根源上调理问题体质。'
    },
    //首要解决问题
    firstList: [
      {
        title: '血糖不稳',
        icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/ed919df4f797860027bde267ec121f26.png',
        text: '脂肪肝跟胰岛素抵抗是密切相关的，胰岛素抵抗容易出现血糖升高，使过多的糖转化为脂肪，体内血脂随之偏高，从而导致过多脂肪在肝脏内进行沉积，形成脂肪肝。所以这类体质的首要解决问题，一定是平衡血糖'
      },
      {
        title: '饮食失衡',
        icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/a5f5a329cdfeb397856195986be52e3e.png',
        text: '饮食结构的失衡，加剧激素紊乱问题，同时，紊乱问题又会反过来加重人体对碳水、糖油的渴望'
      },
      {
        title: '情绪压力',
        icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/486210ed748d37014db8fe4b7e236df0.png',
        text: '熬夜、精神压力等不良生活习惯会加剧胰岛素分泌紊乱，增加进食欲望'
      }
    ],
    plan1: {
      less: '5-8',
      lessImage:
        'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/d26bcb9445d5577f1b4fab07d034aca4.png',
      methodImage:
        'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/332d25e2ef242f21c56209c64ddc104e.png',
      consultUrl:
        '/miniProgram?userName=gh_0d804ee2c21b&path=pages%2Fimage-page%2Findex%3Fqrcode%3Dhttps%253A%252F%252Fbtw-common-data.betterwestar.com%252Fbtw-admin%252Fadmin-common-data%252F2025-04%252F9ff0e3092c20656949115654e4732b27_wh%253D396_396.png',
      miniProgramRouterUrl:
        'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/d6f02180594828b90dd9c5dd24396191.png'
    },
    plan2: {
      //cardImage: "https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/61b88e8f80d356896ecf29dbe62588dc.png",
      cardImage:
        'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/23f0d6705f32aeb5f9403cfb0a921f8b.png',
      food: '苹果',
      buyUrl: '',
      rightImage:
        'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/0113cd2eb49aa5ac68d50d8c6dab9ad3.png'
    },
    recommendation: {
      controlFood: {
        desc: '高糖食物、精制碳水、劣质脂肪',
        list: [
          {
            icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/04bdeeceadddba4acb9696a3d2f50137.png',
            name: '炸鸡、薯条',
            tips: '油炸食品是一种高热量、高脂肪、高盐分的食品，会让肝脏对废物的处理量增加，所以肝脏的负担就变得更加沉重，加剧失衡问题。'
          },
          {
            icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/d9535c2379d65c6486792e31209edee8.png',
            name: '榴莲',
            tips: '榴莲属于一种高糖水果，对于胰岛素敏感性低的人群，如果吃高糖食物，很可能会影响到全身各器官的代谢功能，加重代谢负担。'
          },
          {
            icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/6ebb47caaae1fce35585be324b95b610.png',
            name: '五花肉',
            tips: '五花肥肉是高脂、高热量的肉类食品，含有饱和脂肪，可能增加胰岛素抵抗，使血糖控制更为困难。'
          },
          {
            icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/2b4a702bce20819809f20aa543e175ab.png',
            name: '冰淇淋',
            tips: '冰淇淋是高糖、高脂食物，能在短时间内让血糖陡然升高，从而加剧胰岛素抵抗问题。'
          },
          {
            icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/5476d8bef889a96696aac94fd26b81f1.png',
            name: '黄油、奶油',
            tips: '过多的油脂进入体内之后，会影响身体的代谢功能，很容易加剧肾上腺激素分泌失衡的问题。'
          },
          {
            icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/8f571914a7532ab6caba54d9d71ae92d.png',
            name: '糕点',
            tips: '糕点中含有大量的糖，当人体血糖水平因高糖食物而大幅度波动时，会给身体和内分泌系统造成巨大压力，加剧胰岛素抵抗问题。'
          },
          {
            icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/0bccd6958be2c9adeebbda93dc006cb7.png',
            name: '榨菜',
            tips: '腌制食物中含有大量的盐，高盐食物会加剧胰岛素抵抗的问题。'
          },
          {
            icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/c6f8e5e7bb082576e52799fd30a68383.png',
            name: '动物内脏',
            tips: '对于肝脏胰岛素抵抗型体质人群，其胆固醇排放速度慢于常人，血脂相应更高，因此一定要减少胆固醇的摄入。'
          }
        ]
      },
      recommendFood: {
        desc: '富含纤维素的低糖食物、高蛋白食物',
        list: [
          {
            icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/09305cf7d12fa3c65633582350ec5b14.png',
            name: '苹果'
          },
          {
            icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/c19bec0a25483cb9019f8451e3868b29.png',
            name: '燕麦'
          },
          {
            icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/8929a809e5041fbcd5fc03da0b088574.png',
            name: '豆腐'
          }
        ]
      },
      consultUrl: ''
    },
    selectPlanUrl:
      '/miniProgram?userName=gh_0d804ee2c21b&path=pages%2Fimage-page%2Findex%3Fqrcode%3Dhttps%253A%252F%252Fbtw-common-data.betterwestar.com%252Fbtw-admin%252Fadmin-common-data%252F2025-04%252F87b508b22e070d0cda35178e304fadf0_wh%253D396_396.png'
  },
  {
    type: 3,
    title: '肾上腺素失衡型',
    enTitle: 'epinephrine',
    fat: '腰腹',
    weekCardIcon:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/bba87687edc374338c547af607741663.png',
    titleImage:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/548a6a691fe59257a79667b65b931cdf.png', //类型图片
    foodImage:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/60b79c7a64578269af95654ba8d54317.png', //超级食物图片
    coachSay: {
      text: '<span style="background: #FFFDC0;">饮食结构不合理、心理压力大</span>是引起肾上腺素失衡的最主要原因。这类人群可能会让身体和精神常处于战斗或逃跑状态，从而导致<span style="background: #FFFDC0;">身体通过提高皮质醇分泌来“保护”自身，以便储存多余的脂肪</span>以备不时之需。而脂肪主要集中在腰腹，下肢相对较细的原因是，超量的皮质醇导致大腿肌肉和臀部肌肉被分解作为功能，在视觉上出现下肢不粗、没有屁股的感觉。',
      effect:
        '肾上腺素的失衡，很容易导致<span style="background: #FFFDC0;">向心型脂肪堆积，就算你吃的很少，也无法减除腹部脂肪，</span>因为皮质醇的威力实在太大了，它能让其他燃脂激素都失效，随着年龄增大， 减脂会愈加困难，同时，它还会让皮肤暗沉，部分人群会易长痘，皮肤外油内干。若长期不改善，可能会增加<span style="background: #FFFDC0;">水牛背、皮肤紫纹、植物神经紊乱</span>等问题出现的风险。建议在<span style="background: #FFFDC0;"  >专业医生或营养师</span>的帮助下及时从根源上调理问题体质。'
    },
    //首要解决问题
    firstList: [
      {
        title: '慢性压力',
        icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/4326e88967bb4766e8525bb0c594329f.png',
        text: '长期紧绷、焦虑的情绪状态，加剧肾上腺素水平失衡'
      },
      {
        title: '饮食失衡',
        icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/a5f5a329cdfeb397856195986be52e3e.png',
        text: '饮食结构的失衡，加剧激素紊乱问题，同时，紊乱问题又会反过来加重人体对碳水、糖油的渴望'
      },
      {
        title: '肾上腺素疲劳',
        icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/f02d0c718cfbfecaf3d68e7d29007d58.png',
        text: '因分泌皮质醇的肾上腺素不堪重负导致的消耗抵抗'
      }
    ],
    plan1: {
      less: '5-8',
      lessImage:
        'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/d26bcb9445d5577f1b4fab07d034aca4.png',
      methodImage:
        'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/a1b8f83135012a8a984cfcdb1f14f6af.png',
      consultUrl:
        '/miniProgram?userName=gh_0d804ee2c21b&path=pages%2Fimage-page%2Findex%3Fqrcode%3Dhttps%253A%252F%252Fbtw-common-data.betterwestar.com%252Fbtw-admin%252Fadmin-common-data%252F2025-04%252Fbc52dfbff0fdf9ddea23be78f0aa28c3_wh%253D396_396.png',
      miniProgramRouterUrl:
        'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/92fc46a29cdcf9b9923a6e62934dbaf6.png'
    },
    plan2: {
      //cardImage: "https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/5fa35cce6964e7c40882b22c6552cf89.png",
      cardImage:
        'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/1eec1a1b539b199ec956a1baa904f854.png',
      food: '桑葚',
      buyUrl: '',
      rightImage:
        'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/35fb0dd8763cd208f650afa4d4116924.png'
    },
    recommendation: {
      controlFood: {
        desc: '咖啡因、高糖食物、精制碳水、油炸食物',
        list: [
          {
            icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/6ebb47caaae1fce35585be324b95b610.png',
            name: '肥肉',
            tips: '过多的油脂会加重肾上腺代谢的负担，导致皮质醇增加，加剧肾上腺激素失衡的问题。'
          },
          {
            icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/f9a2360b8d848db7c0d7f429657695e5.png',
            name: '蛋糕',
            tips: '蛋糕中含有大量的糖，当人体血糖水平因高糖食物而大幅度波动时，会给身体和内分泌系统造成巨大压力，肾上腺此时就会释放过量的皮质醇激素，加剧炎症反应。'
          },
          {
            icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/6472242f754fe93ddaa77b701110a09a.png',
            name: '酒精',
            tips: '酒精的摄入会造成皮质醇分泌的增加，进而降低胰岛素的敏感度，促进脂肪的堆积。'
          },
          {
            icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/c6f8e5e7bb082576e52799fd30a68383.png',
            name: '动物内脏',
            tips: '对于肾上腺激素失衡的人群，其胆固醇排放速度慢于常人，血脂相应更高，因此一定要减少胆固醇的摄入。'
          },
          {
            icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/5476d8bef889a96696aac94fd26b81f1.png',
            name: '黄油、奶油',
            tips: '过多的油脂进入体内之后，会影响身体的代谢功能，很容易加剧肾上腺激素分泌失衡的问题。'
          },
          {
            icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/58b49fe55a4e7109cac16b44d35a8cb3.png',
            name: '可乐',
            tips: '可乐中含有大量的糖和食品添加剂，当人体血糖水平因高糖食物而大幅度波动时，会给身体和内分泌系统造成巨大压力，肾上腺此时就会释放过量的皮质醇激素，加剧炎症反应。'
          },
          {
            icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/04bdeeceadddba4acb9696a3d2f50137.png',
            name: '炸鸡',
            tips: '油炸食品是一种高热量、高脂肪、高盐分的食品，会让肾脏对废物的处理量增加，所以肾脏的负担就变得更加沉重，加剧肾上腺激素失衡问题。'
          },
          {
            icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/4667a84f768143e01c3853750138814c.png',
            name: '咖啡',
            tips: '过量的咖啡因会导致皮质醇过量分泌，进而降低胰岛素的敏感度，促进脂肪的堆积。'
          }
        ]
      },
      recommendFood: {
        desc: '抗炎食物、高蛋白食物',
        list: [
          {
            icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/0ada13efd431443ce8c2c9c8c09edcf0.png',
            name: '桑葚'
          },
          {
            icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/9c308ff5d3177bc58b9ed832d7418902.png',
            name: '西兰花'
          },
          {
            icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/7f4055b8662f0471635f1c0a9fd63556.png',
            name: '胡萝卜'
          }
        ]
      },
      consultUrl: ''
    },
    selectPlanUrl:
      '/miniProgram?userName=gh_0d804ee2c21b&path=pages%2Fimage-page%2Findex%3Fqrcode%3Dhttps%253A%252F%252Fbtw-common-data.betterwestar.com%252Fbtw-admin%252Fadmin-common-data%252F2025-04%252F87b508b22e070d0cda35178e304fadf0_wh%253D396_396.png'
  },
  {
    type: 4,
    title: '雌激素失衡型（偏低）',
    enTitle: 'low_hormone',
    fat: '臀腿',
    weekCardIcon:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/9dd86702d9217779d930b8159b47021f.png',
    titleImage:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/09f78296b755357849f406c6df13a7e5.png', //类型图片
    foodImage:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/464171146101aef5a3ea64feba1cc0ec.png', //超级食物图片
    coachSay: {
      text: '雌激素失衡(偏低)型问题体质的形成原因主要与慢性压力、身体炎症、饮食结构失衡、年龄有关。雌激素分泌紊乱会导致皮下脂肪聚集，在前期主要表现为外周型肥胖（梨形身材），但随着雌激素的持续减少，更多的雄激素分泌促进腹部脂肪堆积，会出现风险更高的中心型肥胖（苹果形身材）。',
      effect:
        '女性雌激素偏低可能会造成<span style="background: #FFFDC0;">月经不调、卵巢功能衰退、皮肤加速衰老</span>等后果，若长期偏低，会导致<span style="background: #FFFDC0;">生殖器官免疫力下降，</span>出现阴道炎、子宫肌瘤、多囊等妇科疾病，严重的话还可能导致不孕现象。建议在<span style="background: #FFFDC0;"  >专业医生或营养师</span>的帮助下及时从根源上调理问题体质。'
    },
    //首要解决问题
    firstList: [
      {
        title: '代谢紊乱',
        icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/15080387967002fb29bf42082fc33b2b.png',
        text: '雌激素分泌紊乱，势必加重身体代谢负担，脂肪和毒素堆积在身体中无法正常排出，易诱发多种妇科疾病'
      },
      {
        title: '饮食失衡',
        icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/a5f5a329cdfeb397856195986be52e3e.png',
        text: '饮食结构的失衡，加剧激素紊乱问题，同时，紊乱问题又会反过来加重人体对碳水、糖油的渴望'
      },
      {
        title: '情绪不稳',
        icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/486210ed748d37014db8fe4b7e236df0.png',
        text: '雌激素会通过影响人体中枢神经系统，强烈影响女性情绪，易感到低落、焦虑，对身心健康造成较大伤害'
      }
    ],
    plan1: {
      less: '5-8',
      lessImage:
        'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/20340cd218508c2c67febd652b4461a3.png',
      methodImage:
        'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/d389d1071d20ad95f0d7402327a9dfce.png',
      consultUrl:
        '/miniProgram?userName=gh_0d804ee2c21b&path=pages%2Fimage-page%2Findex%3Fqrcode%3Dhttps%253A%252F%252Fbtw-common-data.betterwestar.com%252Fbtw-admin%252Fadmin-common-data%252F2025-04%252Ff4f693e8566e7c68e0188fc498868f19_wh%253D396_396.png',
      miniProgramRouterUrl:
        'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/0de298ce85322dfcbb5bd948e7125a8c.png'
    },
    plan2: {
      //cardImage: "https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/2039f24a4cd5bc16fc23a2ce0cd98465.png",
      cardImage:
        'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/5ca9c25e48b6bb25c588b4e94017280f.png',
      food: '黄豆',
      buyUrl: '',
      rightImage:
        'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/3525bb6603c8aeb2e93256a2297e5e08.png'
    },
    recommendation: {
      controlFood: {
        desc: '精加工食品、高糖食物、高胆固醇食物',
        list: [
          {
            icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/6ebb47caaae1fce35585be324b95b610.png',
            name: '肥肉',
            tips: '肥肉中的脂肪和胆固醇含量都较高，经常食用会导致体内的雄性激素增加，从而加剧雌激素偏低的问题。'
          },
          {
            icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/f9a2360b8d848db7c0d7f429657695e5.png',
            name: '蛋糕',
            tips: '奶油蛋糕等高糖食物会引起血糖波动，进而影响雌激素的合成与分泌，加剧雌激素偏低的问题。'
          },
          {
            icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/6472242f754fe93ddaa77b701110a09a.png',
            name: '酒精',
            tips: '酒精会扰乱女性身体中的内分泌水平，对于雌激素本身就偏低的人群来说，会加剧失衡问题。'
          },
          {
            icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/c6f8e5e7bb082576e52799fd30a68383.png',
            name: '动物内脏',
            tips: '动物内脏含有大量的胆固醇，它们进入人体后，会打破人体正常的内分泌，引起卵巢功能下降，雌激素分泌紊乱，导致雌激素水平下降。'
          },
          {
            icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/5476d8bef889a96696aac94fd26b81f1.png',
            name: '黄油、奶油',
            tips: '黄油、奶油中含有大量的油脂、盐和糖，会增加体内雌激素的代谢和排泄压力，加剧雌激素偏低的问题。'
          },
          {
            icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/58b49fe55a4e7109cac16b44d35a8cb3.png',
            name: '可乐',
            tips: '可乐中含有大量的糖和人工代糖，会增加体内雌激素的代谢和排泄压力，加剧雌激素偏低的问题。'
          },
          {
            icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/04bdeeceadddba4acb9696a3d2f50137.png',
            name: '炸鸡',
            tips: '油炸食物中含有丙烯酰胺，这是一种中等有毒物质，会对女性卵巢产生一定的负作用。经常摄入，会打破女性体内雌激素的平衡，引发妇科疾病。'
          },
          {
            icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/4667a84f768143e01c3853750138814c.png',
            name: '咖啡',
            tips: '咖啡、浓茶等食物都含有大量的咖啡因。咖啡因进入人体后，会抑制雌激素的分泌，长期如此，就会导致女性体内的雌激素水平偏低。'
          }
        ]
      },
      recommendFood: {
        desc: '富含植物雌激素的食物、富含维生素E和D的食物',
        list: [
          {
            icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/f86561c9cf0f0f922b2b3255f628b9f1.png',
            name: '黄豆'
          },
          {
            icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/352519c14bc96396f08bf0218f8bd790.png',
            name: '蜂王浆'
          },
          {
            icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/8fec012de6fc1a19064774454b09ee3e.png',
            name: '南瓜'
          }
        ]
      },
      consultUrl: ''
    },
    selectPlanUrl:
      '/miniProgram?userName=gh_0d804ee2c21b&path=pages%2Fimage-page%2Findex%3Fqrcode%3Dhttps%253A%252F%252Fbtw-common-data.betterwestar.com%252Fbtw-admin%252Fadmin-common-data%252F2025-04%252F87b508b22e070d0cda35178e304fadf0_wh%253D396_396.png'
  },
  {
    type: 5,
    title: '雌激素失衡型（偏高）',
    enTitle: 'high_hormone',
    fat: '臀腿',
    weekCardIcon:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/98a225db8670196b34429ff0d83ba5be.png',
    titleImage:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/923f8b1616bdd3dfa9a6a1d34c071e0c.png', //类型图片
    foodImage:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/912ae70ed4353db091f2d699dfb375cf.png', //超级食物图片
    coachSay: {
      text: '雌激素失衡（偏高）型问题体质的形成原因多种多样，主要是<span style="background: #FFFDC0;">慢性压力、身体炎症、加工食品摄入、外源性毒素</span>（农药残留）影响等。女性雌激素偏高，会扰乱机体内分泌平衡状态，从而出现<span style="background: #FFFDC0;">体重增加的情况，而脂肪又有储存雌激素的功能，最终就导致了越来越多</span>的脂肪沉积，造成比别人更易胖的结果，尤其是怀孕后，减脂会愈加困难。',
      effect:
        '此类人群，很容易将自己<span style="background: #FFFDC0;">误认为是雌激素失衡（偏低）型问题，</span>进而采取完全错误的改善方式导致<span style="background: #FFFDC0;">问题加剧。若雌激素长期偏高，</span>除更易胖外，还可能会引起卵巢疾病（如子宫肌瘤、卵巢癌）、甲亢和肝硬化等危害，建议在<span style="background: #FFFDC0;"  >专业医生或营养师</span>的帮助下及时从根源上调理问题体质。'
    },
    //首要解决问题
    firstList: [
      {
        title: '代谢紊乱',
        icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/15080387967002fb29bf42082fc33b2b.png',
        text: '雌激素分泌紊乱，势必加重身体代谢负担，脂肪和毒素堆积在身体中无法正常排出，易诱发多种妇科疾病'
      },
      {
        title: '饮食失衡',
        icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/a5f5a329cdfeb397856195986be52e3e.png',
        text: '饮食结构的失衡，加剧激素紊乱问题，同时，紊乱问题又会反过来加重人体对碳水、糖油的渴望'
      },
      {
        title: '情绪不稳',
        icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/486210ed748d37014db8fe4b7e236df0.png',
        text: '雌激素会通过影响人体中枢神经系统，强烈影响女性情绪，易感到低落、焦虑，对身心健康造成较大伤害'
      }
    ],
    plan1: {
      less: '5-8',
      lessImage:
        'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/4cb926fd3181e5b28efd19121c35baa7.png',
      methodImage:
        'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/e5a0c23a9012fcfbb95152dc78a28171.png',
      consultUrl:
        '/miniProgram?userName=gh_0d804ee2c21b&path=pages%2Fimage-page%2Findex%3Fqrcode%3Dhttps%253A%252F%252Fbtw-common-data.betterwestar.com%252Fbtw-admin%252Fadmin-common-data%252F2025-04%252Fc2c914703569b43c6d381db9abbed5b4_wh%253D396_396.png',
      miniProgramRouterUrl:
        'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/b69270e539242e06f6b0d19554d3e3a4.png'
    },
    plan2: {
      //cardImage: "https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/7c3773d302802146be75e6ca010f8f4e.png",
      cardImage:
        'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/3e716f5ce6b38ff0ae43138baaab4037.png',
      food: '黑芝麻',
      buyUrl: '',
      rightImage:
        'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/db5d4b0912730ca212794c645e86e4b3.png'
    },
    recommendation: {
      controlFood: {
        desc: '动植物雌激素含量高的滋补食物、易引起炎症的食物',
        list: [
          {
            icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/ac748ef2af62be23209109d24497ce42.png',
            name: '牛奶',
            tips: '牛奶中含有动物性的雌激素，同时也可刺激雌激素分泌，对于雌激素偏高的人群，应控制好牛奶的摄入量，否则会加剧雌激素偏高的问题。'
          },
          {
            icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/701c352be923221860e5027dc4eac883.png',
            name: '蜂蜜',
            tips: '蜂蜜中含有动物性的雌激素或具雌激素样的物质，例如黄酮类化合物，若不控制好蜂蜜的摄入量，可能会加剧雌激素偏高的问题。'
          },
          {
            icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/3eec37e15dc8fba9daa95b23dfd74c92.png',
            name: '阿胶',
            tips: '阿胶对于雌激素较低的女性来说是非常好的滋补品，但对于雌激素较高的人群来说，长期食用反而会加剧雌激素偏高的问题。'
          },
          {
            icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/0b1845475c955958140ce269ad908f73.png',
            name: '黄豆类制品',
            tips: '豆浆中含有植物性的雌激素，同时也可刺激雌激素分泌，对于雌激素偏高的人群，应控制好黄豆类制品的摄入量，否则会加剧雌激素偏高的问题。'
          },
          {
            icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/6472242f754fe93ddaa77b701110a09a.png',
            name: '酒精',
            tips: '酒精会影响下丘脑和脑垂体等荷尔蒙系统，使雌激素分泌更加紊乱。'
          },
          {
            icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/4667a84f768143e01c3853750138814c.png',
            name: '咖啡',
            tips: '咖啡豆中含有植物性的雌激素，对于雌激素偏高的人群，应控制好咖啡的摄入量，否则会加剧雌激素偏高的问题。'
          },
          {
            icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/f3cb0aea530352bfc4df76f171e31fa3.png',
            name: '奶油制品',
            tips: '奶油中含有大量的油脂，胆固醇含量也比较高，经常食用会导致雌激素的分泌愈加紊乱，且增加身体器官代谢负担。'
          },
          {
            icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/a691b490296a0aa11716333213d1435c.png',
            name: '高糖食物',
            tips: '当人体血糖水平因高糖食物而大幅度波动时，会给身体和内分泌系统造成巨大压力，进一步加剧雌激素失衡问题。'
          }
        ]
      },
      recommendFood: {
        desc: '富含硒和锌的食物、十字花科蔬菜',
        list: [
          {
            icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/3609067b192a68c5dcc9b2fd91ecba28.png',
            name: '黑芝麻'
          },
          {
            icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/dbf5d136fe3719b67e61557c8e55f64b.png',
            name: '紫菜、海带'
          },
          {
            icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/8fec012de6fc1a19064774454b09ee3e.png',
            name: '南瓜'
          }
        ]
      },
      consultUrl: ''
    },
    selectPlanUrl:
      '/miniProgram?userName=gh_0d804ee2c21b&path=pages%2Fimage-page%2Findex%3Fqrcode%3Dhttps%253A%252F%252Fbtw-common-data.betterwestar.com%252Fbtw-admin%252Fadmin-common-data%252F2025-04%252F87b508b22e070d0cda35178e304fadf0_wh%253D396_396.png'
  },
  {
    type: 6,
    title: '甲状腺素失衡型',
    enTitle: 'thyroid',
    fat: '全身',
    weekCardIcon:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/241da5a952df339073e5c785e6897137.png',
    titleImage:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/5b7a0b174440128975986a48da05a4c8.png', //类型图片
    foodImage:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/6c6554abff05931cd132f502c3cfa36e.png', //超级食物图片
    coachSay: {
      text: '甲状腺激素失衡型的体质，在为了控制体重刻意少吃时，反而会让身体<span style="background: #FFFDC0;">利用储存脂肪的方式抵抗饥饿，并且会降低身体消耗能量的速率。</span>所以这类人群很容易感到“喝水都胖”。<span style="background: #FFFDC0;">不规律的饮食与作息、碘元素的失衡与食物不耐受、雌激素过量分泌等，</span>都是可能引起甲状腺激素失衡问题的原因。如您已经出现<span style="background: #FFFDC0;">体重增加、掉发、头发分岔、指甲脆弱、皱纹增多</span>等表症的话，建议您尽快进行体质调理。',
      effect:
        '甲状腺激素的长期失衡，不仅会让<span style="background: #FFFDC0;">身体代谢速率大幅降低，引起更易胖</span>的问题，还有可能导致<span style="background: #FFFDC0;">身体排毒能力下降、免疫力减弱，</span>很容易引起感冒和流感；同时，<span style="background: #FFFDC0;">还会增加身体血液循环压力，影响全身血液循环，</span>增加多种疾病的患病风险，如胆酸结晶、高血压，高血脂以及冠心病等。建议在<span style="background: #FFFDC0;"  >专业医生或营养师</span>的帮助下及时从根源上调理问题体质。'
    },
    //首要解决问题
    firstList: [
      {
        title: '代谢缓慢',
        icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/c17e56cfa0149747f35a22fa90783b4c.png',
        text: '甲状腺激素分泌紊乱，势必加重身体代谢负担，脂肪和毒素堆积在身体中无法正常排出，易诱发多种妇科疾病'
      },
      {
        title: '饮食失衡',
        icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/a5f5a329cdfeb397856195986be52e3e.png',
        text: '饮食结构的失衡，加剧激素紊乱问题，同时，紊乱问题又会反过来加重人体对碳水、糖油的渴望'
      },
      {
        title: '情绪压力',
        icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/486210ed748d37014db8fe4b7e236df0.png',
        text: '熬夜、精神压力等不良生活习惯会加剧胰岛素分泌紊乱，增加进食欲望'
      }
    ],
    plan1: {
      less: '5-8',
      lessImage:
        'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/d0678d256115445acc1b2984636bde67.png',
      methodImage:
        'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/0464817ecdbf6798ac84be2e49e2131c.png',
      consultUrl:
        '/miniProgram?userName=gh_0d804ee2c21b&path=pages%2Fimage-page%2Findex%3Fqrcode%3Dhttps%253A%252F%252Fbtw-common-data.betterwestar.com%252Fbtw-admin%252Fadmin-common-data%252F2025-04%252Ff997cd389c9588800f26fc9e19f7fcfe_wh%253D396_396.png',
      miniProgramRouterUrl:
        'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/252de87a2427961f7b28a59523c1d467.png'
    },
    plan2: {
      //cardImage: "https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/d5fadb58eb04cf6bc8fef5a25b24ee0e.png",
      cardImage:
        'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/9130c31c56f853494a4573d84e54e65c.png',
      food: '扁桃仁',
      buyUrl: '',
      rightImage:
        'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/c71522eb724b6bbb549572af92622d59.png'
    },
    recommendation: {
      controlFood: {
        desc: '十字花科类蔬菜、高胆固醇食物、高蛋白食物、含麸质食物',
        list: [
          {
            icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/71caca17ae4ec89acc64e0726fc857b3.png',
            name: '卷心菜',
            tips: '含氰化物的食物可引起甲状腺肿大，如卷心菜、卷心菜、油菜等，会加剧甲状腺激素分泌失衡问题。'
          },
          {
            icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/7a1eae07f2090703a5928baed0b23b3e.png',
            name: '面包',
            tips: '面包是用小麦制作而成，含有大量麸质，而乳甲状腺组织与麸质中的细菌毒素结构相似，因此易导致免疫系统无差别攻击甲状腺组织和麸质，加剧甲状腺激素失衡。'
          },
          {
            icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/ee524a6e9f6eb149cc7c67a67b0f35aa.png',
            name: '花生米',
            tips: '对于甲状腺激素分泌过多的人群，尽量少食用花生米，因为花生中含有较高的碘元素，会刺激甲状腺分泌甲状腺素，从而加重代谢过程，使症状更加严重。'
          },
          {
            icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/d5199e0d8e31a73b16df8f3aaddb8953.png',
            name: '方便面',
            tips: '方便面属于高盐食物，对于甲状腺激素分泌过少的人群，如果吃太多高盐食物，可能会引起水钠潴留，加重水肿。'
          },
          {
            icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/5476d8bef889a96696aac94fd26b81f1.png',
            name: '黄油、奶油',
            tips: '过多的油脂进入体内之后，会影响身体的代谢功能，很容易加剧甲状腺激素分泌失衡的问题。而且，黄油属于高碘食物，对于甲状腺激素分泌过少的人群，一定要避免食用。'
          },
          {
            icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/6472242f754fe93ddaa77b701110a09a.png',
            name: '酒精',
            tips: '过量饮酒可能导致甲状腺功能的抑制，影响激素的正常分泌和代谢。'
          },
          {
            icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/04bdeeceadddba4acb9696a3d2f50137.png',
            name: '炸鸡',
            tips: '油炸食品是一种高热量、高脂肪、高盐分的食品，会加重甲状腺的代谢负担，加剧失衡问题。'
          },
          {
            icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/c6f8e5e7bb082576e52799fd30a68383.png',
            name: '动物内脏',
            tips: '对于甲状腺激素分泌过少的人群，其胆固醇排放速度慢于常人，血脂相应更高，因此一定要减少胆固醇的摄入。'
          }
        ]
      },
      recommendFood: {
        desc: '富含硒、锌微量元素的食物、优质脂肪食物',
        list: [
          {
            icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/27f2022df5a6f2ee1c9c4d14931fa662.png',
            name: '扁桃仁'
          },
          {
            icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/45ebd2d989bdaa7df0c1d8a48f79083b.png',
            name: '椰子油'
          },
          {
            icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/beb9784e17ffed53cc5d81344fdecc22.png',
            name: '巴西坚果'
          }
        ]
      },
      consultUrl: ''
    },
    selectPlanUrl:
      '/miniProgram?userName=gh_0d804ee2c21b&path=pages%2Fimage-page%2Findex%3Fqrcode%3Dhttps%253A%252F%252Fbtw-common-data.betterwestar.com%252Fbtw-admin%252Fadmin-common-data%252F2025-04%252F87b508b22e070d0cda35178e304fadf0_wh%253D396_396.png'
  }
]
const BuriedData = {
  simple: {
    page: 'BG_TIZHIPINGGU_JIEGUO_YINSHI',
    bgPlan1: 'BG_TIZHIPINGGU_JIEGUO_YINSHI_PLAN1',
    clickPlan1: 'CLICK_TIZHIPINGGU_JIEGUO_YINSHI_PLAN1',
    bgPlan2: 'BG_TIZHIPINGGU_JIEGUO_YINSHI_PLAN2',
    clickPlan2: 'CLICK_TIZHIPINGGU_JIEGUO_YINSHI_PLAN2',
    clickShare: 'CLICK_TIZHIPINGGU_JIEGUO_YINSHI_SHARE'
  },
  liver: {
    page: 'BG_TIZHIPINGGU_JIEGUO_GZ',
    bgPlan1: 'BG_TIZHIPINGGU_JIEGUO_GZ_PLAN1',
    clickPlan1: 'CLICK_TIZHIPINGGU_JIEGUO_GZ_PLAN1',
    bgPlan2: 'BG_TIZHIPINGGU_JIEGUO_GZ_PLAN2',
    clickPlan2: 'CLICK_TIZHIPINGGU_JIEGUO_GZ_PLAN2',
    clickShare: 'CLICK_TIZHIPINGGU_JIEGUO_GZ_SHARE'
  },
  epinephrine: {
    page: 'BG_TIZHIPINGGU_JIEGUO_SSX',
    bgPlan1: 'BG_TIZHIPINGGU_JIEGUO_SSX_PLAN1',
    clickPlan1: 'CLICK_TIZHIPINGGU_JIEGUO_SSX_PLAN1',
    bgPlan2: 'BG_TIZHIPINGGU_JIEGUO_SSX_PLAN2',
    clickPlan2: 'CLICK_TIZHIPINGGU_JIEGUO_SSX_PLAN2',
    clickShare: 'CLICK_TIZHIPINGGU_JIEGUO_SSX_SHARE'
  },
  low_hormone: {
    page: 'BG_TIZHIPINGGU_JIEGUO_CJSDI',
    bgPlan1: 'BG_TIZHIPINGGU_JIEGUO_CJSDI_PLAN1',
    clickPlan1: 'CLICK_TIZHIPINGGU_JIEGUO_CJSDI_PLAN1',
    bgPlan2: 'BG_TIZHIPINGGU_JIEGUO_CJSDI_PLAN2',
    clickPlan2: 'CLICK_TIZHIPINGGU_JIEGUO_CJSDI_PLAN2',
    clickShare: 'CLICK_TIZHIPINGGU_JIEGUO_CJSDI_SHARE'
  },
  high_hormone: {
    page: 'BG_TIZHIPINGGU_JIEGUO_CJSGAO',
    bgPlan1: 'BG_TIZHIPINGGU_JIEGUO_CJSGAO_PLAN1',
    clickPlan1: 'CLICK_TIZHIPINGGU_JIEGUO_CJSGAO_PLAN1',
    bgPlan2: 'BG_TIZHIPINGGU_JIEGUO_CJSGAO_PLAN2',
    clickPlan2: 'CLICK_TIZHIPINGGU_JIEGUO_CJSGAO_PLAN2',
    clickShare: 'CLICK_TIZHIPINGGU_JIEGUO_CJSGAO_SHARE'
  },
  thyroid: {
    page: 'BG_TIZHIPINGGU_JIEGUO_JZX',
    bgPlan1: 'BG_TIZHIPINGGU_JIEGUO_JZX_PLAN1',
    clickPlan1: 'CLICK_TIZHIPINGGU_JIEGUO_JZX_PLAN1',
    bgPlan2: 'BG_TIZHIPINGGU_JIEGUO_JZX_PLAN2',
    clickPlan2: 'CLICK_TIZHIPINGGU_JIEGUO_JZX_PLAN2',
    clickShare: 'CLICK_TIZHIPINGGU_JIEGUO_JZX_SHARE'
  }
}
export { ResultData, BuriedData }
